export default "__VITE_ASSET__DqijhuLB__"